module.exports = __webpack_public_path__ + "assets/img/logo.e25919c0.png";